export const questionTemplateFormat = [
  'Title',
  'Title_Image',
  'Question_Type',
  'Status',
  'OptionA',
  'OptionA_Type',
  'OptionA_Flag',
  'OptionA_Insight',
  'OptionB',
  'OptionB_Type',
  'OptionB_Flag',
  'OptionB_Insight',
  'OptionC',
  'OptionC_Type',
  'OptionC_Flag',
  'OptionC_Insight',
  'OptionD',
  'OptionD_Type',
  'OptionD_Flag',
  'OptionD_Insight',
  'Source',
  'Grade',
  'Bloom_Level',
  'Difficulty',
  'Topic',
  'Creator',
  'Reviewer',
  'Approver',
  'Competency',
  'Taxonomy',
  'Strand',
  'User_Type',
  'Language',
  'Variant_Of',
  'Transilation_Of',
  'Standard',
]
export const questionEditTemplateFormat = [
  'Question_Id',
  'Title',
  'Title_Image',
  'OptionA',
  'OptionA_Type',
  'OptionA_Flag',
  'OptionA_Insight',
  'OptionB',
  'OptionB_Type',
  'OptionB_Flag',
  'OptionB_Insight',
  'OptionC',
  'OptionC_Type',
  'OptionC_Flag',
  'OptionC_Insight',
  'OptionD',
  'OptionD_Type',
  'OptionD_Flag',
  'OptionD_Insight',
]

export const testEventTemplateFormat = [
  'name',
  'description',
  'product_id',
  'mode_of_exam',
  'location',
  'test_tracks',
  'dates',
  'start_time',
  'end_time',
  'restrictions',
]

export const evaluationUploadFormat = [
  'CandidateId',
  'Name',
  'ApplicationId',
  'CandidateImage',
  'SktId',
  'is_attended',
  'is_disqualified',
  'school_id',
  '1',
  '2',
  '3',
  '4',
]

export const themeImportFormat = ['name', 'subject_id']

export const topicImportFormat = ['name', 'sub_theme_id']

export const subjectImportFormat = ['name', 'code']

export const subThemeImportFormat = ['name', 'theme_id']

export const reportThemeImportFomart = ['name', 'theme_ids']

export const paperTemplateImportFomart = [
  'section_name',
  'sub_sec_name',
  'subject_id',
  'theme_id',
  'sub_theme_id',
  'topic_id',
  'report_theme_id',
  'question_type_id',
  'blooms_level_id',
  'difficult_level_id',
  'competency_id',
  'strand_id',
  'base_lang',
  'target_lang',
  'no_of_questions',
  'mark_per_question',
]